import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
  CircularProgress,
} from "@mui/material";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { useLocation } from "react-router-dom";
import { getStoreListForUserRequest } from "../../redux/Dashboard/dashboardSlice";
import { useDispatch, useSelector } from "react-redux";
import { createDiamondPointOrderRequest } from "../../redux/DiamondPoint/DiamondPointSlice";
import DiamondIcon from "@mui/icons-material/Diamond";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import { useAppTheme } from "../../theme/useAppTheme";
import useCurrency from "../../hooks/useCurrency";
import { store } from "../../redux/store";

export default function DiamondPointsScreen() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, storeList, appConfig } = useSelector(
    (state) => state.dashboard,
  );
  const location = useLocation();
  const { row, type } = location.state || {};
  console.log("selected row", row);

  const diamondRedeemConfig = appConfig?.diamondRedeemConfig?.configAmount || 0;
  const currentPoints = row?.points || 0;
  const perPointValue = diamondRedeemConfig;
  const maxValue = currentPoints * perPointValue;
  console.log("perPointValue", perPointValue);

  const themeColors = useAppTheme();

  const { symbol } = useCurrency();

  const [points, setPoints] = useState("");
  const [value, setValue] = useState("");
  const [agreed, setAgreed] = useState(false);
  const [openTC, setOpenTC] = useState(false);

  const handlePointsChange = (e) => {
    const p = e.target.value;
    if (!/^\d*\.?\d*$/.test(p)) return;
    if (Number(p) > currentPoints) {
      toast.error("Entered points are greater than available points");
      return;
    }
    setPoints(p);
    setValue(p ? p * perPointValue : "");
  };

  const handleRedeem = () => {
    console.log("handleRedeem");
    if (!selectedStore) {
      toast.warm("Please select a store");
      return;
    }

    const body = {
      pointsToRedeem: Number(points),
      orderAmount: Number(value),
      Id: row?._id,
      branchcode: selectedStore.branchCode,
      onSuccess: () => {
        const created = store.getState().diamondPoint?.data || {};
        const order = {
          ...created,
          pointsRedeemed:
            created.pointsRedeemed ?? created.pointsToRedeem ?? Number(points),
          amount: created.amount ?? created.orderAmount ?? Number(value),
          store: created.store || {
            branchName: selectedStore.branchName,
            phone: selectedStore.phone,
            branchCode: selectedStore.branchCode,
            address1: selectedStore.address1,
            address2: selectedStore.address2,
            address3:
              selectedStore.address3 ||
              [selectedStore.city, selectedStore.pincode]
                .filter(Boolean)
                .join(" - "),
          },
        };
        navigate("/DiamondPointPendingOrder", {
          state: { order, id: row?._id, type: "Diamondpoint" },
        });
      },
    };

    dispatch(createDiamondPointOrderRequest(body));
  };

  const handleClose = () => {
    navigate("/RedeemHistory");
  };

  const handleValueChange = (e) => {
    const v = e.target.value;
    if (!/^\d*\.?\d*$/.test(v)) return;
    if (Number(v) > maxValue) {
      toast.error("Entered value is greater than available value");
      return;
    }
    setValue(v);
    setPoints(v ? v / perPointValue : "");
  };

  // ----------- Select Store Logic -------------
  const [selectedStore, setSelectedStore] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [openSheet, setOpenSheet] = useState(false);
  useEffect(() => {
    if (openSheet) {
      dispatch(
        getStoreListForUserRequest({
          id: `${process.env.REACT_APP_JEWELLER_ID}`,
        }),
      );
    }
  }, [openSheet, dispatch]);

  const filteredStores = (storeList || [])
    .filter((s) => s && s.branchName)
    .filter(
      (s) =>
        s.branchName.toLowerCase().includes((searchTerm || "").toLowerCase()) ||
        s.city.toLowerCase().includes((searchTerm || "").toLowerCase()) ||
        s.pincode.toLowerCase().includes((searchTerm || "").toLowerCase()),
    );

  // -------------------------------------------

  return (
    <Box
      sx={{
        background: themeColors.scaffoldGradientColors,
        pb: { xs: 2, md: 0 },
        overflowX: "hidden",
        maxWidth: 1400,
        mx: "auto",
        px: { xs: 1.5, md: 0 },
        border: `1px solid ${themeColors.scaffold}`,
        color: themeColors.text,
      }}
    >
      <Card
        sx={{
          borderRadius: 4,
          p: { xs: 2, sm: 3 },
          width: "100%",
          maxWidth: 600,
          mx: "auto",
          marginTop: { xs: 2, md: "50px" },
          marginBottom: { xs: 2, md: "50px" },
          background: themeColors.bigContainer,
          border: `1px solid ${themeColors.scaffold}`,
          color: themeColors.text,
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <CloseIcon
            sx={{ cursor: "pointer", color: themeColors.text }}
            onClick={handleClose}
          />
        </Box>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            mb: 3,
            textAlign: "center",
            background: themeColors.bigContainer,
          }}
        >
          Diamond Points
        </Typography>

        {/* Current Points */}
        <Card
          sx={{
            borderRadius: 3,
            mb: 3,
            textAlign: "center",
            background: "#a01877",
            border: `1px solid ${themeColors.scaffold}`,
          }}
        >
          <CardContent>
            <Typography variant="subtitle2" sx={{ color: themeColors.text }}>
              Current Balance
            </Typography>

            <Grid container spacing={2} sx={{ mt: 1, justifyContent: "center" }}>
              <Grid size={{ xs: 6 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <DiamondIcon
                    fontSize="small"
                    sx={{ color: themeColors.text }}
                  />
                  <Typography
                    variant="caption"
                    sx={{ color: themeColors.text }}
                  >
                    Diamond Points
                  </Typography>
                </Box>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, color: themeColors.text }}
                >
                  {currentPoints}
                </Typography>
              </Grid>

              <Grid size={{ xs: 6 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    color: themeColors.text,
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{ color: themeColors.text }}
                  >
                    Value
                  </Typography>{" "}
                </Box>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "700", color: themeColors.text }}
                >
                  {symbol}{currentPoints * perPointValue}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {/* Redeem Input */}
        <Card
          sx={{
            borderRadius: 3,
            mb: 3,
            background: themeColors.bigContainer,
            border: `1px solid ${themeColors.scaffold}`,
            color: themeColors.text,
          }}
        >
          <CardContent>
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Redeem
            </Typography>

            <Grid container spacing={2} sx={{ mt: 1, color: themeColors.text, alignItems: "center" }}>
              <Grid
                size={{ xs: 12, sm: 5 }}
                sx={{
                  color: themeColors.text,
                  border: `1px solid ${themeColors.scaffold}`,
                }}
              >
                <TextField
                  label="Points"
                  fullWidth
                  value={points}
                  onChange={handlePointsChange}
                  sx={{
                    input: { color: themeColors.text },
                    label: { color: themeColors.text },
                    "& .MuiOutlinedInput-root fieldset": {
                      borderColor: themeColors.scaffold,
                    },
                  }}
                />
              </Grid>

              <Grid
                size={{ xs: 12, sm: 2 }}
                textAlign="center"
                sx={{
                  py: 1,
                  color: themeColors.text,
                  border: `1px solid ${themeColors.scaffold}`,
                }}
              >
                <SwapHorizIcon fontSize="large" />
              </Grid>

              <Grid
                size={{ xs: 12, sm: 5 }}
                sx={{
                  color: themeColors.text,
                  border: `1px solid ${themeColors.scaffold}`,
                }}
              >
                <TextField
                  label="Value"
                  fullWidth
                  value={value}
                  onChange={handleValueChange}
                  sx={{
                    input: { color: themeColors.text },
                    label: { color: themeColors.text },
                    "& .MuiOutlinedInput-root fieldset": {
                      borderColor: themeColors.scaffold,
                    },
                  }}
                />
              </Grid>
            </Grid>

            <Typography
              sx={{
                mt: 2,
                fontSize: 13,
                textAlign: "center",
                color: themeColors.text,
              }}
            >
              1 Point = {symbol}{perPointValue}
            </Typography>
          </CardContent>
        </Card>

        {/* Select Store */}
        {!selectedStore && (
          <Card
            sx={{
              padding: 2,
              cursor: "pointer",
              borderRadius: 2,
              display: "flex",
              justifyContent: "space-between",
              mb: 3,
              background: themeColors.bigContainer,
              color: themeColors.text,
              border: `1px solid ${themeColors.scaffold}`,
            }}
            onClick={() => setOpenSheet(true)}
          >
            <Typography>Select Store</Typography>
            <Typography>▶</Typography>
          </Card>
        )}

        {selectedStore && (
          <Card
            sx={{
              padding: 2,
              borderRadius: 2,
              mb: 3,
              border: `1px solid ${themeColors.scaffold}`,
              color: themeColors.text,
              background: themeColors.bigContainer,
            }}
          >
            <Typography variant="h6">{selectedStore.branchName}</Typography>
            <Typography>Phone: {selectedStore.phone}</Typography>
            <Typography>Code: {selectedStore.branchCode}</Typography>
            <Typography>
              Address:{" "}
              {`${selectedStore.address1 || ""} ${
                selectedStore.address2 || ""
              } ${selectedStore.city || ""} - ${selectedStore.pincode}`}
            </Typography>
            <Button
              sx={{
                mt: 2,
                background: themeColors.primary,
                color: themeColors.text,
                "&:hover": {
                  background: themeColors.svgColor,
                },
                border: `1px solid ${themeColors.scaffold}`,
              }}
              variant="outlined"
              onClick={() => setOpenSheet(true)}
            >
              Change Store
            </Button>
          </Card>
        )}

        <FormControlLabel
          control={
            <Checkbox
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
            />
          }
          label={
            <span>
              I agree to{" "}
              <span
                style={{
                  color: themeColors.text,
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={() => setOpenTC(true)}
              >
                terms and conditions
              </span>
            </span>
          }
        />
        {agreed && points > 0 && selectedStore && (
          <Button
            variant="contained"
            fullWidth
            sx={{
              py: 1.3,
              borderRadius: 2,
              background: themeColors.primary,
              color: themeColors.text,
              "&:hover": {
                background: themeColors.svgColor,
              },
              border: `1px solid ${themeColors.scaffold}`,
            }}
            onClick={() => handleRedeem()}
          >
            Redeem
          </Button>
        )}

        {/* Dialog for Store Selection */}
        <Dialog open={openSheet} onClose={() => setOpenSheet(false)} fullWidth>
          <DialogTitle
            sx={{
              color: themeColors.primary,
              background: themeColors.mediumContainer,
            }}
            fontWeight="bold"
          >
            Select Store
          </DialogTitle>
          <DialogContent
            sx={{
              background: themeColors.mediumContainer,
              color: themeColors.text,
            }}
          >
            <TextField
              fullWidth
              placeholder="Search store"
              fontWeight="bold"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              sx={{
                input: { color: themeColors.text },
                label: { color: themeColors.text },
                "& .MuiOutlinedInput-root fieldset": {
                  borderColor: themeColors.scaffold,
                },
              }}
            />

            {filteredStores.map((store) => (
              <Card
                key={store._id}
                sx={{
                  padding: 2,
                  mb: 1,
                  cursor: "pointer",
                  background: themeColors.mediumContainer,
                  color: themeColors.text,
                  border: `1px solid ${themeColors.scaffold}`,
                }}
                onClick={() => {
                  setSelectedStore(store);
                  setOpenSheet(false);
                }}
              >
                <Typography variant="h6">{store.branchName}</Typography>
                <Typography>Phone: {store.phone}</Typography>
                <Typography>Code: {store.branchCode}</Typography>
                <Divider sx={{ mb: 2 }} />
                <Typography>
                  Address:{" "}
                  {`${store.address1 || ""} ${store.address2 || ""} ${
                    store.city || ""
                  } - ${store.pincode}`}
                </Typography>
              </Card>
            ))}

            {filteredStores.length === 0 && (
              <Typography>No stores found.</Typography>
            )}
          </DialogContent>
        </Dialog>
        <Dialog
          open={openTC}
          onClose={() => setOpenTC(false)}
          fullWidth
          sx={{ "& .MuiPaper-root": { borderRadius: 3, padding: 2 } }}
        >
          <DialogTitle sx={{ fontWeight: 700, textAlign: "center" }}>
            Terms and Conditions
          </DialogTitle>

          <DialogContent>
            <Typography sx={{ mb: 1, lineHeight: 1.6 }}>
              <b>1.</b> Diamond points can only be redeemed for charges on
              Making charge of jewellery.
            </Typography>

            <Typography sx={{ mb: 1, lineHeight: 1.6 }}>
              <b>2.</b> Unused diamond points will expire after 12 months from
              the date of issuance.
            </Typography>

            <Typography sx={{ mb: 1, lineHeight: 1.6 }}>
              <b>3.</b> Diamond points are non-transferable and cannot be
              exchanged for cash.
            </Typography>

            <Typography sx={{ mb: 1, lineHeight: 1.6 }}>
              <b>4.</b> Any fraudulent use of diamond points will result in
              immediate account suspension.
            </Typography>

            <Box sx={{ textAlign: "center", mt: 3 }}>
              <Button
                onClick={() => setOpenTC(false)}
                variant="outlined"
                sx={{ borderRadius: 8, px: 4 }}
              >
                Close
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      </Card>
    </Box>
  );
}
